import { css } from 'emotion'

export const CollapsibleDivStyles = css``
